import * as React from 'react';
import { clsx } from 'clsx';
import * as styles from './Filters.css';
import { TPosition } from './types';

interface IFiltersProps {
  position: TPosition;
}

export const Filters = React.forwardRef<HTMLDivElement, React.PropsWithChildren<IFiltersProps>>(function Filters(
  { children, position },
  ref,
) {
  return (
    <div className={styles['holder']}>
      <div data-name="Filters" ref={ref} className={clsx(styles['container'], position && styles[position])}>
        <div className={styles['content']}>{children}</div>
      </div>
    </div>
  );
});
